"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _job = require("@/api/job/job");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "应用监控",
  data: function data() {
    return {
      listQuery: {},
      systemInfo: {
        jobCount: "N/A",
        runningInstanceCount: "N/A",
        failedInstanceCount: "N/A",
        serverTime: "UNKNOWN",
        timezone: "UNKNOWN"
      },
      activeWorkerCount: "N/A",
      workerList: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listQuery.appId = 3;
      (0, _job.getApp)(this.listQuery).then(function (response) {
        _this.systemInfo = response.data.data;
      });
      (0, _job.getWorker)(this.listQuery).then(function (response) {
        _this.workerList = response.data.data;
        var num = 0;
        _this.workerList.forEach(function (w) {
          if (w.status !== 9999) {
            num++;
          }
        });
        _this.activeWorkerCount = num;
      });
    },
    timestamp2Str: function timestamp2Str(ts) {
      if (ts < 10000) {
        return "N/A";
      }
      try {
        if (ts) {
          var time = new Date(ts);
          var y = time.getFullYear();
          var M = time.getMonth() + 1;
          var d = time.getDate();
          var h = time.getHours();
          var m = time.getMinutes();
          var s = time.getSeconds();
          return y + "-" + this.addZero(M) + "-" + this.addZero(d) + " " + this.addZero(h) + ":" + this.addZero(m) + ":" + this.addZero(s);
        } else {
          return "";
        }
      } catch (e) {
        return "N/A";
      }
    },
    addZero: function addZero(m) {
      return m < 10 ? "0" + m : m;
    }
  }
};